enum UniqueDomIdentifiers {
  billingView = 'billing-view',
  preferredStoreView = 'preferred-store-view',
  preferredStoreViewContactInfo = 'preferred-store-view-contact-info',
  preferredStoreViewWhoPickup = 'preferred-store-view-who-pickup',
  giftWrap = 'giftwrap',
  invoiceView = 'invoice-view',
}

export default UniqueDomIdentifiers;
